import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { llmNamespaceResources } from '@etherworks/shared-i18n/llm-web';

const resources = llmNamespaceResources;

const supportedLanguages = Object.keys(resources);
const namespaces = Array.from(
  new Set(
    Object.values(resources).flatMap(languageResources => Object.keys(languageResources))
  )
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    load: 'languageOnly',
    defaultNS: 'common',
    ns: namespaces,
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'etherworks-language',
      caches: ['localStorage'],
    },
  });

export default i18n;
